// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"154f208e-168":"1f4616a9de3a0b14e253","154f208e-452":"faa79cb6bcf2379ce084","154f208e-379":"acbcd6de70707cefac4e","154f208e-83":"5819000203571e80edbc"}[chunkId] + ".js";
};